var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"create-button --base-color --underline-effect",attrs:{"to":{ name: 'createPost' }}},[_vm._v("create")])}
var staticRenderFns = []

export { render, staticRenderFns }